<template>
  <div class="prediction" id="prediction" ref="prediction"></div>
</template>

<script>
export default {
  name: "prediction",
  props: ["needData"],
  data() {
    return {};
  },
  created(){
    
  },
  mounted() {
    // setTimeout(()=>{
    //    this.prediction(this.needData);
    // },200)
  //  this.prediction(this.needData);
  
  },
  watch: {
    "needData"() {
      this.prediction(this.needData);
    },
  },
  methods: {
    prediction(param) {
      let myEchart = this.$echarts.init(document.getElementById("prediction"));
      // var echarts = require("echarts");
         
      
      var legendData = [];

      param.forEach(item => {
        legendData.push(item.name)
      });

      let option = {
        backgroundColor: "",

        legend: {
          show: true,
          data: legendData,
          icon: "ret",
          right: "0%",
          top: "15%",
          orient: "vertical",
          height: 200,
          itemGap: 30,
          itemWidth: 12,
          itemHeight: 12,
          formatter: function (name) {
            var data = param.filter((value) => {
              return value.name == name;
            })[0];

            return `${data.name}     {a|${data.value}}`;
          },
          itemStyle: {
            borderWidth: 0,
          },
          textStyle: {
            color: "#cee1e5",
            fontSize: 12,
            rich: {
              a: {
                color: "#fff",
                align: "right",
              },
            },
          },
        },
        series: [
          {
            name: "总考生数量",
            type: "pie",
            radius: ["48%", "59%"],
            center: ["30%", "50%"],
            hoverAnimation: false,

            color: [
              "#00d0ff",
              "#feb12a",
              "#ff612a",
              "#ff2a2a",
              "rgb(200, 114, 56)",
              "rgb(142, 244, 126)",
              "#c487ee",
              "rgb(73, 183, 101)",
              "#deb140",
              "rgb(233, 136, 116)",
              "rgb(84, 178, 224)",
              "rgb(47, 172, 143)",
            ],
            itemStyle: {
              //图形样式
              normal: {
                borderColor: "#464f56",
                borderWidth: 3,
              },
            },
            label: {
              show: false,
            },
            labelLine: {
              normal: {
                show: false,
              },
            },
            data: param,
          },
          {
            type: "pie",
            hoverAnimation: false, //鼠标经过的特效
            radius: ["49.5%", "44%"],
            center: ["30%", "50%"],
            startAngle: 225,
            labelLine: {
              normal: {
                show: false,
              },
            },
            label: {
              normal: {
                position: "center",
              },
            },
            data: [
              {
                value: 1,
                itemStyle: {
                  normal: {
                    color: "#4f636c",
                  },
                },
              },
            ],
          },
          {
            type: "pie",
            hoverAnimation: false, //鼠标经过的特效
            radius: ["42%", "41%"],
            center: ["30%", "50%"],
            startAngle: 225,
            labelLine: {
              normal: {
                show: false,
              },
            },
            label: {
              normal: {
                position: "center",
              },
            },
            data: [
              {
                value: 1,
                itemStyle: {
                  normal: {
                    color: "#95b3bd",
                  },
                },
              },
            ],
          },
        ],
      };

      myEchart.setOption(option);
      window.addEventListener("resize", () => {
        myEchart.resize();
      });
    },
  },
};
</script>

<style scoped>
.prediction {
  width: 100%;
  height: 100%;
}
</style>